<template>
	<div ref="chartRef" :class="className" :style="{ height: height, width: width }"></div>
</template>

<script>
	import * as echarts from 'echarts'
	import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'
	import { base64ToFile } from '@/utils/index'
	export default {
		name: 'JrEcharts',
		components: {},
		props: {
			className: {
				type: String,
				default: 'chart'
			},
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			options: {
				type: Object,
				required: true
			},
			autoResize: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				chart: null
			}
		},
		computed: {},
		watch: {
			options: {
				handler(options) {
					// 监听options变化，更新图表
					this.setOptions(options)
				},
				deep: true
			}
		},
		created() {},
		mounted() {
			this.initChart()
			if (this.autoResize) {
				addResizeListener(this.$el, this.resize)
			}
		},
		beforeDestroy() {
			if (!this.chart) {
				return
			}
			if (this.autoResize) {
				removeResizeListener(this.$el, this.resize)
			}
			this.chart.dispose()
			this.chart = null
		},
		methods: {
			initChart() {
				this.chart = echarts.init(this.$el)
				this.setOptions(this.options)
			},
			setOptions(options) {
				if (this.chart) {
					this.chart.setOption(options, true)
				}
			},
			resize() {
				if (this.chart) {
					this.chart.resize()
				}
			},

			// 添加导出图片方法
			exportImage() {
				if (!this.chart) {
					return ''
				}
				// 获取图表的 base64 图片数据
				return this.chart.getDataURL({
					type: 'png',
					pixelRatio: 2, // 提高图片质量
					backgroundColor: '#fff'
				})
			},

			// 导出图片为文件对象
			exportAsFile(fileName = 'chart.png') {
				const base64Data = this.exportImage()
				if (!base64Data) {
					return null
				}

				// // 将base64转换为Blob对象
				// const byteString = atob(base64Data.split(',')[1])
				// const mimeString = base64Data
				// 	.split(',')[0]
				// 	.split(':')[1]
				// 	.split(';')[0]
				// const ab = new ArrayBuffer(byteString.length)
				// const ia = new Uint8Array(ab)

				// for (let i = 0; i < byteString.length; i++) {
				// 	ia[i] = byteString.charCodeAt(i)
				// }

				// const blob = new Blob([ab], { type: mimeString })

				// // 创建File对象
				// return new File([blob], fileName, { type: mimeString })

				return base64ToFile(base64Data, fileName)
			}
		}
	}
</script>

<style lang="scss" scoped></style>
